<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      row-id="amzSkuCode"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="351"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:monthProfit="{ row }">
        <span v-if="row.monthProfit < 0" style="color: #F54E60;">
          {{ row.monthProfit }}
        </span>
        <span v-else style="color: #67C23A;">{{ row.monthProfit }}</span>
      </template>
      <template v-slot:monthProfitRatio="{ row }">
        <span v-if="row.monthProfitRatio < 0" style="color: #F54E60;">
          {{ row.monthProfitRatio }}%
        </span>
        <span v-else style="color: #67C23A;">{{ row.monthProfitRatio }}%</span>
      </template>
      <template v-slot:addUpProfit="{ row }">
        <span v-if="row.addUpProfit < 0" style="color: #F54E60;">
          {{ row.addUpProfit }}
        </span>
        <span v-else style="color: #67C23A;">{{ row.addUpProfit }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import {
  format,
  add,
  divide,
} from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    loading: { type: Boolean, default: false },
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    disabledPrint: { typ: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    highlightCurrentRow: { typ: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .map((t) => {
          if (t.field == 'saleQty') {
            const val = totalColumnValues[t.field]
            return val ? format(val) : '0'
          } else {
            return ''
          }
        })
      result[0] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 260
    },
    remove({ amzFirstDemandDetailCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .ecomAmzFirstDemandDetailDelApi({ amzFirstDemandDetailCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    async editClosed({ row }) {
      const { inCtnQty, qty } = row
      const ctnQty = divide(qty, inCtnQty)
      row.ctnQty = ctnQty

      const result = await this.$refs.skuTable.validate(row)

      if (!result) {
        this.loadingOpen()
        this.$api
          .ecomAmzFirstDemandDetailEditSaveApi({
            ...row,
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      } else {
        await this.$refs.skuTable.blur()
      }
    },
    async getTableData() {
      const { tableData } = await this.$refs.skuTable.getTableData()
      return tableData
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error('请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
